/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { DocumentDisplayModel as AceXFoundPortalCoreCaqModelsDocumentDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { GutachtenBefangenheitDisplayModel as AceXFoundPortalCoreCaqModelsGutachtenBefangenheitDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/gutachten-befangenheit-display-model';
import { GutachtenDisplayModel as AceXFoundPortalCoreCaqModelsGutachtenDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/gutachten-display-model';
import { GutachtenListDisplayModel as AceXFoundPortalCoreCaqModelsGutachtenListDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/gutachten-list-display-model';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';

@Injectable({
providedIn: 'root',
})

export class GutachtenService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiGutachtenGetPersonalReviewListGet
   */
  static readonly ApiGutachtenGetPersonalReviewListGetPath = '/api/Gutachten/GetPersonalReviewList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenGetPersonalReviewListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGetPersonalReviewListGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsGutachtenListDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenGetPersonalReviewListGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsGutachtenListDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenGetPersonalReviewListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGetPersonalReviewListGet(params?: {
  }): Observable<Array<AceXFoundPortalCoreCaqModelsGutachtenListDisplayModel>> {

    return this.apiGutachtenGetPersonalReviewListGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsGutachtenListDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsGutachtenListDisplayModel>)
    );
  }

  /**
   * Path part for operation apiGutachtenGet
   */
  static readonly ApiGutachtenGetPath = '/api/Gutachten';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGet$Response(params?: {
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsGutachtenDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenGetPath, 'get');
    if (params) {
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsGutachtenDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGet(params?: {
    gutachtenId?: string;
  }): Observable<AceXFoundPortalCoreCaqModelsGutachtenDisplayModel> {

    return this.apiGutachtenGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsGutachtenDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsGutachtenDisplayModel)
    );
  }

  /**
   * Path part for operation apiGutachtenUpdateGutachtenPatch
   */
  static readonly ApiGutachtenUpdateGutachtenPatchPath = '/api/Gutachten/UpdateGutachten';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenUpdateGutachtenPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGutachtenUpdateGutachtenPatch$Response(params?: {
    body?: AceXFoundPortalCoreCaqModelsGutachtenDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenUpdateGutachtenPatchPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenUpdateGutachtenPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGutachtenUpdateGutachtenPatch(params?: {
    body?: AceXFoundPortalCoreCaqModelsGutachtenDisplayModel
  }): Observable<void> {

    return this.apiGutachtenUpdateGutachtenPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiGutachtenSubmitGutachtePatch
   */
  static readonly ApiGutachtenSubmitGutachtePatchPath = '/api/Gutachten/SubmitGutachte';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenSubmitGutachtePatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenSubmitGutachtePatch$Response(params?: {
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenSubmitGutachtePatchPath, 'patch');
    if (params) {
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenSubmitGutachtePatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenSubmitGutachtePatch(params?: {
    gutachtenId?: string;
  }): Observable<void> {

    return this.apiGutachtenSubmitGutachtePatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiGutachtenUpdateGutachtenBefangenheitPatch
   */
  static readonly ApiGutachtenUpdateGutachtenBefangenheitPatchPath = '/api/Gutachten/UpdateGutachtenBefangenheit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenUpdateGutachtenBefangenheitPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGutachtenUpdateGutachtenBefangenheitPatch$Response(params?: {
    body?: AceXFoundPortalCoreCaqModelsGutachtenBefangenheitDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenUpdateGutachtenBefangenheitPatchPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenUpdateGutachtenBefangenheitPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiGutachtenUpdateGutachtenBefangenheitPatch(params?: {
    body?: AceXFoundPortalCoreCaqModelsGutachtenBefangenheitDisplayModel
  }): Observable<void> {

    return this.apiGutachtenUpdateGutachtenBefangenheitPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiGutachtenGetDocumentGutachtenIdDocumentIdGet
   */
  static readonly ApiGutachtenGetDocumentGutachtenIdDocumentIdGetPath = '/api/Gutachten/GetDocument/{gutachtenId}/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenGetDocumentGutachtenIdDocumentIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGetDocumentGutachtenIdDocumentIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    gutachtenId: string;
    documentId: string;
    loadContent?: boolean;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenGetDocumentGutachtenIdDocumentIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('gutachtenId', params.gutachtenId, {});
      rb.path('documentId', params.documentId, {});
      rb.query('loadContent', params.loadContent, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenGetDocumentGutachtenIdDocumentIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGetDocumentGutachtenIdDocumentIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    gutachtenId: string;
    documentId: string;
    loadContent?: boolean;
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiGutachtenGetDocumentGutachtenIdDocumentIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

  /**
   * Path part for operation apiGutachtenGetDocumentsAsZipGutachtenIdGet
   */
  static readonly ApiGutachtenGetDocumentsAsZipGutachtenIdGetPath = '/api/Gutachten/GetDocumentsAsZip/{gutachtenId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGutachtenGetDocumentsAsZipGutachtenIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGetDocumentsAsZipGutachtenIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    gutachtenId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, GutachtenService.ApiGutachtenGetDocumentsAsZipGutachtenIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiGutachtenGetDocumentsAsZipGutachtenIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGutachtenGetDocumentsAsZipGutachtenIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    gutachtenId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiGutachtenGetDocumentsAsZipGutachtenIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

}